









































import { Vue, Component, Prop } from 'vue-property-decorator';
import { MenuItem } from '@/types/apiServerContract';
import SimpleSlider from '@/core/ui-components/SimpleSlider.vue';
import serverContextService from '@/core/serverContext.service';
import CampaignIcon from '@/project/product/campaigns/CampaignIcon.vue';

@Component({
    components: { SimpleSlider, CampaignIcon }
})
export default class MainNavigationSlider extends Vue {
    @Prop({ type: Array, required: true })
    private menus!: MenuItem[];

    @Prop({ type: Boolean, required: true })
    private megaMenuShown!: boolean;

    @Prop({ type: Object, required: false })
    private activeMenu!: MenuItem;

    private mouseEnter(menu: MenuItem) {
        this.$emit('activeMenuChanged', menu);
    }

    private mouseLeave(menu: MenuItem) {
        this.$emit('cancelMegaMenuNavigation', menu);
    }

    private get campaignCode() {
        return this.campaignLink?.url.split('/').pop();
    }

    private get campaignLink() {
        return serverContextService.settings?.menuCampaignLink;
    }
}
